function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeadlightOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504.533 504.533",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0075ff"
    },
    d: "M248.567,422.96C111.036,422.559,0,346.39,0,252.43C0,158.461,111.002,81.174,248.533,81.575l0,0 c34.074,111.019,34.15,229.478,0.239,340.71L248.567,422.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0075ff"
    },
    d: "M496,217.76H308.267c-4.71,0-8.533-3.823-8.533-8.533s3.823-8.533,8.533-8.533H496 c4.71,0,8.533,3.823,8.533,8.533S500.71,217.76,496,217.76"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0075ff"
    },
    d: "M496,303.093H308.267c-4.71,0-8.533-3.823-8.533-8.533c0-4.71,3.823-8.533,8.533-8.533H496 c4.71,0,8.533,3.823,8.533,8.533C504.533,299.27,500.71,303.093,496,303.093"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0075ff"
    },
    d: "M496,388.426H308.267c-4.71,0-8.533-3.823-8.533-8.533s3.823-8.533,8.533-8.533H496 c4.71,0,8.533,3.823,8.533,8.533S500.71,388.426,496,388.426"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0075ff"
    },
    d: "M496,132.426H308.267c-4.71,0-8.533-3.823-8.533-8.533c0-4.71,3.823-8.533,8.533-8.533H496 c4.71,0,8.533,3.823,8.533,8.533C504.533,128.603,500.71,132.426,496,132.426"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadlightOn);
export default __webpack_public_path__ + "static/media/headlight_on.cfea8a73706729741e9cf45c1df4f3db.svg";
export { ForwardRef as ReactComponent };